import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Layout from './components/Layout';
import { authService } from './services/auth';
import { routeModules } from './services/navigation';
import { clearQueryCache } from './services/queryCache';
import './App.css';

const QRCodeList = lazy(routeModules['/qrcodes']);
const Reports = lazy(routeModules['/reports']);
const CompanyPages = lazy(routeModules['/pages']);
const UserManagement = lazy(routeModules['/users']);
const section = Component => <Suspense fallback={<div className="loading-container" role="status" aria-label="Abrindo página"><div className="loading-spinner" /></div>}><Component /></Suspense>;

function App() {
  const [sessionEpoch, setSessionEpoch] = useState(0);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
    const sessionChanged = event => {
      if (event.key?.startsWith('CognitoIdentityServiceProvider.') && (event.key.endsWith('.LastAuthUser') || (event.key.endsWith('.idToken') && !event.newValue))) {
        clearQueryCache();
        setSessionEpoch(value => value + 1);
        checkAuth();
      }
    };
    window.addEventListener('storage', sessionChanged);
    return () => window.removeEventListener('storage', sessionChanged);
  }, []);

  const checkAuth = async () => {
    try {
      const user = await authService.getCurrentUser();
      setIsAuthenticated(!!user);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    authService.signOut();
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="full-page-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ?
            <Navigate to="/dashboard" /> :
            <Login onLogin={handleLogin} />
          }
        />

        <Route
          element={
            isAuthenticated ?
            <Layout key={sessionEpoch} onLogout={handleLogout} /> :
            <Navigate to="/login" />
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/qrcodes" element={section(QRCodeList)} />
          <Route path="/reports" element={section(Reports)} />
          <Route path="/pages" element={section(CompanyPages)} />
          <Route path="/users" element={section(UserManagement)} />
        </Route>

        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;
